import React from "react";
import DocumentTitle from "react-document-title";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

// Internal dependencies.
import SkipLink from "../../../components/SkipLink";
import RenewalNotification from "../../RenewalNotification";
import { getDocumentTitle } from "../helpers";

import * as styles from "./styles.module.scss";
import BlackFridayBanner from "../../BlackFridayBanner/BlackFridayBanner";
import TwoYearOffer from "../../TwoYearOffer/TwoYearOffer";
import PricingMigrationBanner from "../../PricingMigrationBanner";
import PromotionalNotificationArea from "../../PromotionalNotificationArea";
import Sidebar from "../../Sidebar";
import Footer from "../Footer";

/**
 * Wraps a component in the main layout.
 *
 * @param {ReactElement} WrappedComponent The React component to wrap.
 * @param {string}       documentTitle    The document title.
 * @param {Array}        menuItems        The document title.
 *
 * @returns {ReactElement} The main layout with the wrapped component.
 */
// eslint-disable-next-line react/display-name
export default ( WrappedComponent, documentTitle, menuItems, noBackground ) => props => {
	return (
		<DocumentTitle title={ getDocumentTitle( documentTitle ) }>
			<div className={ classNames( styles.layout, styles.columnLayout ) }>
				<SkipLink>
					<FormattedMessage id="skiplink" defaultMessage="Skip to main content" />
				</SkipLink>
				<BlackFridayBanner />
				<div className={ styles.rowLayout }>
					<Sidebar menuItems={ menuItems } />
					<div className={ styles.main }>
						<PricingMigrationBanner />
						<PromotionalNotificationArea />
						<TwoYearOffer />
						<RenewalNotification />
						<div className={ classNames( styles.content, { [ styles.noBackground ]: !! noBackground } ) }>
							<WrappedComponent { ...props } />
						</div>
					</div>
				</div>
				<Footer variant="light" />
				{ /* Portal target for toasts */ }
				<div id="toast-root" className={ styles.toastRoot } />
			</div>
		</DocumentTitle>
	);
};
